import React, { useEffect, useState } from 'react'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { getCountries, getCountryCallingCode, } from 'react-phone-number-input/input'
function PhoneNoField({container,id,max,input_style,min,placeholder,children,type,input_class,value,label,
    ref,pattern,callback,label_class,maxLength,label_style,onkeydown,icon_childer,errorsmsg,mandatory,input_wrapeer}) {
      const [countryCode, setCountryCode] = useState("91")
      const [country, setCountry] = useState("91")
      const [Length, setLength] = useState(12)
      console.log(getCountries());
      useEffect(() => {
        let pTag = document.createElement('p');
        pTag.id = 'ReplaceText';
        pTag.innerHTML = countryCode;
        document.getElementsByClassName('PhoneInputCountry').item(0).appendChild(pTag)
      }, [])
      useEffect(() => {
      const check =   document.getElementById('ReplaceText').innerHTML = "+"+countryCode
      console.log(check);
      }, [countryCode])
      

      
  return (
    <div className={input_wrapeer}>
    <p className={label_class} style={{...label_style}}>
                {label}{(mandatory === true || mandatory === undefined )? '*' : ''} 
              </p>
    <div className={container}>
    {/* <select
  value={country}
  onChange={event => setCountry(event.target.value || undefined)}>
  {getCountries().map((country) => (
    <option key={country} value={country}>
      {getCountryCallingCode(country)}
    </option>
  ))}
</select> */}
  
    <PhoneInput
       className={input_class}
      placeholder={placeholder}
      onCountryChange={(d)=>{
        if (d=== undefined || d === null || d==="") return ""
        console.log(d);
        if (d == "IN") {
          setLength(12)
        } 
        // else if (d =="TC") {
        //   setLength(21)
        // }
        else {
          setLength(20)
        }
        console.log(Length);
        setCountryCode(getCountryCallingCode(d))
      }}
      style={{...input_style,border:errorsmsg?"1px solid #F25B5B":""}}
      defaultCountry={"IN"}
      maxLength={Length}
      onChange={(e) => callback(e,countryCode)}
      {...children}/>
     {/* <p>{countryCode}</p>  */}
              {icon_childer}
    </div>
    {/* {errorsmsg && ( */}
                  <p className="help is-input-danger-message">
                    {errorsmsg?errorsmsg:<span>&nbsp;</span>}
                  </p>
                {/* )} */}

    </div>
  )
}

export default PhoneNoField
